import { render, staticRenderFns } from "./GroupActions.vue?vue&type=template&id=63764e1c&scoped=true&"
import script from "./GroupActions.vue?vue&type=script&lang=ts&"
export * from "./GroupActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63764e1c",
  null
  
)

export default component.exports